import type { enBarcelona } from './en.barcelona';

/** 第 F 階段（barcelona 套件）：巴塞隆納，唯一的海外旅行。「引號」裡的句子是英文練習，保留英文。 */
export const zhTWBarcelona: typeof enBarcelona = {
  barcelona: {
    mapNames: { barcelona: '巴塞隆納' },
    zones: {
      bc_city: '巴塞隆納',
      bc_airport: '埃爾普拉特機場 · 入境',
      bc_guell: '奎爾公園',
      bc_sagrada: '聖家堂與擴展區',
      bc_rambla: '蘭布拉大道',
      bc_gotic: '哥德區',
      bc_park: '城堡公園',
      bc_beach: '舊港與巴塞隆內塔海灘',
    },
    objects: {
      bc_flight: '回程班機 · 巴塞隆納機場',
      bc_aerobus: '機場巴士站（往加泰隆尼亞廣場）',
      bc_metroGuell: '地鐵 L3 · Lesseps',
      bc_metroSagrada: '地鐵 L5 · 聖家堂',
      bc_metroLiceu: '地鐵 L3 · Liceu',
      bc_metroBeach: '地鐵 L4 · 巴塞隆內塔',
      bc_guellBench: '波浪長椅',
      bc_dragon: '馬賽克蜥蜴（el drac）',
      bc_sagrada: '聖家堂',
      bc_canaletes: '卡納萊特斯噴泉',
      bc_flowers: '花攤',
      bc_statue: '人體雕像',
      bc_boqueria: '博蓋利亞市場',
      bc_columbus: '哥倫布紀念柱',
      bc_cathedral: '聖歐拉利亞主教座堂',
      bc_xurros: '吉拿棒巧克力攤',
      bc_castellers: '疊人塔（castellers）',
      bc_petanca: '法式滾球場',
      bc_chiringuito: '海灘小酒吧',
    },
    npc: {
      bc_florist: '賣花的阿姨',
      bc_guide: '聖家堂導覽員',
      bc_waiter: '海灘酒吧服務生',
      bc_avi: '拿著麵包的爺爺',
      bc_tourist: '迷路的台灣遊客',
      bc_busker: '街頭吉他手',
      bc_sardanista: '薩達納舞者',
      bc_petancaMan: '滾球玩家',
      bc_juicer: '果汁小販',
      bc_kid: '溜直排輪的女孩',
      bc_staff: '機場服務台',
      bc_casteller: '疊人塔隊長',
      bc_painter: '肖像畫家',
    },
    items: {},

    metro: {
      text: '巴塞隆納地鐵。要去哪一站？',
      guell: '🟢 L3 · Lesseps（奎爾公園）',
      sagrada: '🔵 L5 · 聖家堂',
      liceu: '🟢 L3 · Liceu（蘭布拉大道）',
      beach: '🟡 L4 · 巴塞隆內塔（海灘）',
      airport: '🟠 L9 · 機場 T1',
      riding: '🚇 車門隨著哨聲關上……出發！',
      fact: '巴塞隆納地鐵 1924 年通車，是西班牙最古老的地鐵之一。一張 T-casual 卡可以搭十趟。',
    },
    aerobus: {
      text: '機場巴士 A1 從 T1 開往加泰隆尼亞廣場，每五分鐘一班，到市中心大約 35 分鐘。',
      go: '🚌 搭車去加泰隆尼亞廣場',
      riding: '藍色巴士駛上高速公路……左邊是蒙特惠克山……加泰隆尼亞廣場到了！',
      arrived: '加泰隆尼亞廣場：鴿子、噴泉，蘭布拉大道就從這裡開始，一路往下通到海邊。',
    },

    sagrada: {
      text: '聖家堂：高第設計的大教堂。1882 年開始興建，到現在「還沒蓋完」，起重機也是風景的一部分。完工後會有 18 座塔。',
      ask: '🗣️ 問導覽員（英文）',
      q: '要怎麼問導覽員教堂什麼時候蓋好？',
      a: ['Excuse me, when will the basilica be finished?', 'Finish when basilica?', 'Basilica done now, yes?'],
      right: '“Good question! The tallest tower, for Jesus, should be ready soon — 172 metres, taller than any other church in the world.”',
      wrong: '導覽員笑著說：“Try again — start with ‘Excuse me…’”',
      phrase: 'Excuse me, when will the basilica be finished?',
    },
    guellBench: {
      text: '奎爾公園露台上的波浪長椅：110 公尺的曲線，全部鋪滿「碎瓷拼貼」（trencadís）——把打碎的磁磚拼成馬賽克。從這裡可以看到整座城市一直到海邊。',
      sit: '🪑 坐下來看城市',
      sat: '藍色、黃色、白色……每一片磁磚形狀都不一樣。下面，聖家堂的塔樓從屋頂之間探出頭來。',
      phrase: 'What a beautiful view!',
      q: '「trencadís」是什麼？',
      a: ['用碎磁磚拼成的馬賽克', '一種加泰隆尼亞麵包', '一張很長的木椅'],
      right: '答對了！高第用的是工廠丟掉的磁磚，一點都不浪費。',
      wrong: '看看這張長椅：它是由成千上萬的小碎片拼成的……',
    },
    dragon: {
      text: '「El drac」：階梯上的馬賽克蠑螈，巴塞隆納被拍最多照片的動物。水從牠的嘴裡流進水池。',
      photo: '📸 拍照',
      done: '喀嚓！其他人都在排隊等著……台灣也有很多龍，不過這一隻全身貼滿磁磚。',
      q: '這隻「龍」其實是……',
      a: ['蠑螈', '鱷魚', '貓'],
      right: '是蠑螈！高第很喜歡動物，把牠們放滿整座公園。',
      wrong: '看看牠短短的腿和長長的尾巴……',
    },
    canaletes: {
      text: '蘭布拉大道頂端的卡納萊特斯噴泉。傳說喝了這裡的水，就一定會再回到巴塞隆納。巴薩球迷也在這裡慶祝勝利。',
      drink: '🚰 喝一口水',
      drank: '又冰又新鮮！現在你總有一天要再回來了。',
      phrase: 'I will come back to Barcelona!',
    },
    statue: {
      text: '人體雕像：一位全身塗成青銅色的人，扮成哥倫布一動也不動。丟一枚硬幣……會發生什麼事？',
      tip: '🪙 丟一枚硬幣（2 枚金幣）',
      moved: '雕像眨了眨眼、鞠了個躬，嘎吱一聲指向大海。然後又定住不動了！',
      poor: '今天沒有硬幣給雕像了。',
    },
    columbus: {
      text: '蘭布拉大道盡頭的哥倫布紀念柱，高 60 公尺，為 1888 年世界博覽會而建。哥倫布指著大海……指向東方，那根本不是美洲的方向！',
      look: '🔭 看他指向哪裡',
      q: '哥倫布指著哪一片海？',
      a: ['地中海', '太平洋', '大西洋'],
      right: '對！巴塞隆納面對地中海，台灣則面對太平洋。',
      wrong: '嗯……巴塞隆納的海溫暖、湛藍、沒有大浪。是哪一片呢？',
    },
    cathedral: {
      text: '聖歐拉利亞主教座堂，建於 1298 至 1420 年。迴廊裡住著十三隻白鵝，代表聖女短暫一生的每一年。',
      geese: '🪿 數數白鵝',
      q: '迴廊裡住著幾隻鵝？',
      a: ['十三隻', '三隻', '三十隻'],
      right: '十三隻，就像歐拉利亞的年紀。每個星期天，大家就在教堂前跳薩達納舞。',
      wrong: '和聖女活過的年數一樣多：她年紀很小……',
    },
    castellers: {
      text: '疊人塔隊（castellers）可以疊到十層樓高。底座叫「pinya」；爬到最頂端的小朋友叫「enxaneta」，人塔完成時會舉起一隻手。',
      cheer: '📣 替小朋友加油',
      cheered: '廣場安靜下來……enxaneta 舉起手……「Castell carregat!」大家鼓掌。接著他們再小心翼翼地爬下來。',
      q: '疊人塔的座右銘是「Força, equilibri, valor i seny」。「seny」是什麼意思？',
      a: ['理智', '噪音', '速度'],
      right: '理智：小心又冷靜。要疊起人塔，四樣缺一不可。',
      wrong: '想想看：要讓大家都不摔下來需要什麼？力量、平衡、勇氣……還有……',
    },
    petanca: {
      text: '法式滾球：把鋼球丟得越靠近小木球（cochonnet）越好。爺爺們每天下午都在這裡玩。',
      throw: '🎯 丟一顆球',
      result: (cm: number) => `你的球停在離小木球 ${cm} 公分的地方。`,
      great: '最接近的一顆！爺爺們點點頭：「molt bé」。',
      again: '🎯 再丟一次',
    },

    flowers: {
      vendor: 'Hello! Roses, tulips, sunflowers — what would you like?',
      ok: 'One sunflower, please.',
      bad: ['Give flower.', 'Sunflower me want.'],
      done: '🌻 一朵用紙包好的向日葵。拿著它走在蘭布拉大道上，每個人都對你微笑。',
      price: 6,
    },
    boqueria: {
      text: '博蓋利亞市場：聖約瑟市場，1840 年至今。五顏六色的紙杯果汁、火腿、水果、魚……這裡的市場早上開門，下午就關了。',
      closed: '博蓋利亞市場現在沒開。巴塞隆納的市場很早開門、下午就關，跟台灣的夜市剛好相反！',
      juice: { vendor: 'Juices! Mango, strawberry, coconut, dragon fruit… which one?', ok: 'A mango juice, please.', bad: ['Mango juice now.', 'Juice of mango give.'], done: '🥭 紙杯裝的冰涼芒果汁。喝一口，蘭布拉大道的熱氣都不見了。', price: 4 },
      ham: { vendor: 'Jamón ibérico, cut thin — a paper cone for you?', ok: 'A cone of jamón, please.', bad: ['Jamón cone me.', 'Want jamón, cone.'], done: '🍖 一紙筒的伊比利火腿，鹹鹹的、軟軟的。在西班牙是一片一片用手切的。', price: 8 },
      fruit: { vendor: 'Fresh fruit cups — melon, kiwi, strawberries!', ok: 'A fruit cup, please.', bad: ['Fruit cup, now!', 'Cup fruit I take.'], done: '🍓 一杯切好的水果，附一支小木叉。好甜！', price: 5 },
    },
    xurros: {
      vendor: 'Churros with thick hot chocolate — breakfast or afternoon snack?',
      ok: 'Churros with chocolate, please.',
      bad: ['Churros chocolate give.', 'Me churros now.'],
      done: '🍫 酥脆的吉拿棒沾著濃到湯匙能站起來的巧克力。這裡的人把它當早餐——或是派對後的清晨點心！',
      price: 6,
    },
    chiringuito: {
      text: '沙灘上的小酒吧：西班牙海鮮飯、加泰隆尼亞焦糖布丁、冰涼的歐洽塔。在西班牙，午餐是兩三點，晚餐是九點，比台灣晚很多！',
      noPaella: '服務生說：“Paella? Not yet — lunch here starts at two! Horchata or a crema catalana while you wait?”',
      paella: { vendor: 'Paella for one? Rice, prawns, mussels, a slice of lemon.', ok: 'A paella, please.', bad: ['Paella me.', 'Give paella now.'], done: '🥘 黃色的飯配上蝦子和檸檬，眼前就是大海。最好吃的是鍋底的鍋巴：「socarrat」。', price: 18 },
      crema: { vendor: 'Crema catalana: custard with burnt sugar on top. Crack it with the spoon!', ok: 'A crema catalana, please.', bad: ['Crema give.', 'Catalana crema now.'], done: '🍮 喀！焦糖像玻璃一樣碎開，底下又冰又滑。', price: 6 },
      horchata: { vendor: 'Cold horchata — made from tiger nuts, very sweet.', ok: 'A horchata, please.', bad: ['Horchata me want.', 'Give horchata.'], done: '🥛 甜甜的、冰冰的、像牛奶一樣。跟家裡的豆漿完全不一樣！', price: 4 },
    },

    talk: {
      bc_florist: [
        '1850 年起蘭布拉大道就有花攤了！4 月 23 日聖喬治節，每個人都會送一朵玫瑰和一本書。“A rose for you!”',
        '鬱金香來自荷蘭，玫瑰是本地的。“Which one do you like?”',
      ],
      bc_guide: [
        '高第說：「大自然是我的老師。」看看裡面的柱子，它們像樹一樣分枝。“Welcome to the Sagrada Família!”',
        '高第在這裡工作了 43 年，就葬在地下室。工程費用全靠門票，政府一毛錢也沒出。',
      ],
      bc_waiter: [
        '午餐？兩點以前沒有，我們這裡就是這樣。晚餐要到九點、十點！“Are you hungry?”',
        '這裡用歐元付錢，不是台幣。一歐元大約 35 元台幣，所以一份海鮮飯……要很多台幣！“The bill, please.”',
      ],
      bc_avi: [
        '每天早上：去麵包店買一條長棍麵包，配一杯咖啡。Pa amb tomàquet：麵包抹上番茄、橄欖油和鹽。試試看！“Good morning!”',
        '我小時候用的是比塞塔。2002 年才換成歐元。現在什麼東西我都要算兩次！',
      ],
      bc_busker: [
        '♪ 加泰隆尼亞倫巴，哥德區街頭的音樂。帽子裡丟一枚硬幣，我就彈你想聽的歌。“Thank you, my friend!”',
        '這把吉他是爺爺教我的。這個廣場的回音是全巴塞隆納最好的。',
      ],
      bc_sardanista: [
        '薩達納舞：大家手牽手圍成圓圈，數著步伐，有短步也有長步。誰都可以加入，你也可以！“Come and dance!”',
        '樂隊叫做 cobla。那支高音笛子叫 flabiol，樂手一手吹笛，一手打小鼓。',
      ],
      bc_petancaMan: [
        '每天下午，同一張椅子、同一群朋友、同一組球。秘訣在手腕。“Your turn!”',
        '滾球是從法國南部傳來的，不過我們在這裡已經玩了一百年。',
      ],
      bc_juicer: [
        '一杯兩歐元，大杯三歐元。八點開門，三點關門，然後回家吃午餐！“Fresh juice!”',
        '火龍果、芒果、鳳梨、椰子……顏色本身就會賣。',
      ],
      bc_kid: [
        '我可以從 W 飯店一路溜到港口，整條海濱步道只要十二分鐘！“Catch me if you can!”',
        '夏天的海水一直到十月都是溫的。今天？有點冷，不過爸爸說我是橡皮做的。',
      ],
      bc_staff: [
        '歡迎來到巴塞隆納！機場巴士每五分鐘一班到市中心，或是搭 L9 地鐵。“Can I help you?”',
        '要回家了嗎？國際航班從 T1 出發，請提早過安檢，巴塞隆納機場很大。',
      ],
      bc_casteller: [
        '我是隊長（cap de colla），由我決定要疊哪一種塔。今天疊「四之八」：八層，每層四個人。“Up we go!”',
        '最壯的人在最底下的 pinya，最輕的小朋友在最上面。每個人都有自己的工作。',
      ],
      bc_painter: [
        '十分鐘畫一幅肖像，炭筆或粉彩。我畫過四十個國家的遊客……還有一個來自台灣的：是你嗎？“Sit down, please!”',
        '最難的是笑容。每個人三分鐘後就笑不出來了。',
      ],
    },
    tourist: {
      intro: '你好！請問，聖家堂怎麼走？我迷路了…',
      help: '🗣️ 用中文幫他',
      q: '怎麼回答他？',
      a: ['坐地鐵 L5 藍線，到 Sagrada Família 站下車。', '一直走到海邊。', '坐飛機回台灣。'],
      right: '「太好了，謝謝你！」他鬆了一口氣，鞠了兩次躬，還從包包裡拿出一塊鳳梨酥送你。🍍',
      wrong: '「海邊？」他一臉困惑地看著地圖。聖家堂在北邊，地鐵站旁邊……',
    },
    hours: '在巴塞隆納，午餐是下午兩點，晚餐是晚上九點。商店中午會休息很久，市場下午就關門。',
  },
};
